import { render, staticRenderFns } from "./ImportView.vue?vue&type=template&id=8df9de08&scoped=true"
import script from "./ImportView.vue?vue&type=script&lang=ts"
export * from "./ImportView.vue?vue&type=script&lang=ts"
import style0 from "./ImportView.vue?vue&type=style&index=0&id=8df9de08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df9de08",
  null
  
)

export default component.exports